import { render, staticRenderFns } from "./TitleDetail.vue?vue&type=template&id=287d177e&scoped=true"
import script from "./TitleDetail.vue?vue&type=script&lang=ts"
export * from "./TitleDetail.vue?vue&type=script&lang=ts"
import style0 from "./TitleDetail.vue?vue&type=style&index=0&id=287d177e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287d177e",
  null
  
)

export default component.exports